import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.v2_backgound};
  padding: 10px;
  width: 100%;
`;

export const Text = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.darkText};
`;
